import AGREGAR_CONTRATO_FIRMA from '@/graphql/mutations/administracion/contratos/contrato/firmas/agregarContratoFirma.gql';
import REMOVER_CONTRATO_FIRMA from '@/graphql/mutations/administracion/contratos/contrato/firmas/removerContratoFirma.gql';
import FIRMAS_POR_CONTRATO from '@/graphql/querys/administracion/contratos/firmas/firmasPorContrato.gql';

export default {
  methods: {
    // AGREGAR FIRMA
    async mixAgregarContratoFirma() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { idContrato } = this;
      const { firma } = this;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_FIRMA,
          variables: { firma },
          update: (store, { data: { agregarContratoFirma } }) => {
            const query = {
              query: FIRMAS_POR_CONTRATO,
              variables: { idContrato },
            };
            const { firmasPorContrato } = store.readQuery(query);
            const firmasPorContratoCopia = firmasPorContrato.slice();
            firmasPorContratoCopia.push(agregarContratoFirma);
            store.writeQuery({
              ...query,
              data: {
                firmasPorContrato: firmasPorContratoCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // ELIMINAR FIRMA
    async mixEliminarContratoFirma() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const idFirma = this.firma.id;
      const { idContrato } = this.firma;
      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_FIRMA,
        variables: {
          id: idFirma,
        },
        update: (store) => {
          const query = {
            query: FIRMAS_POR_CONTRATO,
            variables: { idContrato },
          };
          const data = store.readQuery(query);
          const index = data.firmasPorContrato
            .findIndex(({ id }) => id === idFirma);
          if (index !== -1) {
            data.firmasPorContrato.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
